import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  Button,
  ButtonArea,
  ButtonInverted,
  Container,
  Content,
  Dialog,
  Header,
  Input,
  Row,
  Text,
} from './styles';

const schema = yup
  .number()
  .integer('Amount must be an integer')
  .min(0, 'Amount must be a positive number')
  .typeError('Amount must be a positive number');

const PrepaidBalanceModal = (props) => {
  const {
    company,
    error,
    loading,
    onClose,
    onSubmit,
    show,
  } = props;

  const {
    prepaidBalance,
    balanceAmountUsed,
    id,
  } = company;

  const [value, setValue] = useState();
  const [inputError, setInputError] = useState();

  const handleChange = (e, { value: newValue }) => {
    setInputError(null);
    setValue(newValue);
    schema.validate(newValue)
      .catch((err) => {
        setInputError(err.message);
      });
  };

  // Set value to null when component is unmounted
  useEffect(() => () => {
    setValue(null);
  }, [show]);

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h1">
          Prepaid balance
        </Header>

        <Content>
          <Row>
            <Text>Current prepaid balance</Text>
            <Text>{prepaidBalance}</Text>
          </Row>

          <Row>
            <Text>Change to</Text>
            <Input
              placeholder="Enter dollar amount"
              value={value}
              onChange={handleChange}
            />
          </Row>

          <Row>
            <Text>Prepaid balance used</Text>
            <Text>{balanceAmountUsed}</Text>
          </Row>
        </Content>

        {inputError && (
          <Text.Error>
            {inputError}
          </Text.Error>
        )}

        {(error) && (
          <ErrorHandler
            error={error}
            defaultMessage="Error while saving."
          />
        )}

        <ButtonArea>
          <ButtonInverted onClick={onClose}>
            Cancel
          </ButtonInverted>

          <Button
            onClick={() => onSubmit(id, value)}
            disabled={loading || inputError || value === 0}
            loading={loading}
          >
            Save
          </Button>
        </ButtonArea>
      </Dialog>
    </Container>
  );
};

PrepaidBalanceModal.propTypes = {
  error: PropTypes.PropTypes.shape({
    message: PropTypes.string,
  }),
  company: PropTypes.shape({
    id: PropTypes.string,
    balanceAmountUsed: PropTypes.string,
    prepaidBalance: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

PrepaidBalanceModal.defaultProps = {
  error: null,
  loading: false,
  show: false,
};

export default PrepaidBalanceModal;
